'use client'
import { useTranslations } from 'next-intl'

export default function TopBanner() {
    const t = useTranslations('TopBanner')

    return (
        <div className="w-full bg-muted/30 text-muted-foreground py-2.5 px-4 text-center border-b border-border/50">
            <p className="text-sm font-normal">
                {t('message')}
            </p>
        </div>
    )
}
